
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiGroup as ObcPoiGroupElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-group/poi-group.js';
 
 
 

 
 export const ObcPoiGroup = createComponent({
   react: React,
   tagName: 'obc-poi-group',
   elementClass: ObcPoiGroupElement,
   events: {
     
     onExpand: 'expand' as EventName<CustomEvent<{expand:boolean}>>,
     onCollapseFinished: 'collapse-finished' as EventName<CustomEvent<void>>,
   }
  });
 
 